import { render, staticRenderFns } from "./EventBox.vue?vue&type=template&id=7da278ee&scoped=true"
import script from "./EventBox.vue?vue&type=script&lang=js"
export * from "./EventBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da278ee",
  null
  
)

export default component.exports